new Swiper('.absorbent-products .swiper', {
  slidesPerView: 'auto',
  spaceBetween: 25,
  breakpoints: {
    985: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
})
